import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './JS/App'

//=========================================================================================================================================================================

//Rendering the App.js file
const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
    <App />
)

//=========================================================================================================================================================================